// Module-level holder for per-route SEO metadata during build-time prerendering.
// React never runs `useEffect` during server rendering, so SEO.jsx captures
// its metadata here synchronously during render instead; scripts/prerender.js
// resets this before each route and reads it right after `renderToString`.
let current = null

export const resetSeoData = () => {
  current = null
}

export const setSeoData = data => {
  current = data
}

export const getSeoData = () => current
